import { render, staticRenderFns } from "./XmAddressSelect.vue?vue&type=template&id=6d15e2a7&scoped=true"
import script from "./XmAddressSelect.vue?vue&type=script&lang=js"
export * from "./XmAddressSelect.vue?vue&type=script&lang=js"
import style0 from "./XmAddressSelect.vue?vue&type=style&index=0&id=6d15e2a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15e2a7",
  null
  
)

export default component.exports